export default __webpack_public_path__ + "1306fd75f0d3fdf7279b562368518800.jpg";